<template>  
  <v-layout row wrap style="flex:1 0;overflow:auto;align-items:flex-start;" >
    <v-flex xs6 class="inline-block px-4">
      <v-text-field hide-details :label="$t('Admin.UniteMobile.Form.Key')" v-model="umt_key" />
      <v-text-field hide-details :label="$t('Admin.UniteMobile.Form.Surname')" v-model="umt_libelle" />            
    </v-flex>                         
  </v-layout>
</template>

<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'

@Component({
  name: 'AdminUniteMobileForm'
})
export default class AdminUniteMobileForm extends Vue {  

  get modified(){
    return this.$store.myGetters.modifiedAdmUniteMobile
  }
    
  get umt_key() {
    return this.modified.UMB_KEY!
  }
  set umt_key(value:string) {
    this.$store.myActions.UNITEMOBILE_UPDATE_MODIFIED_ADM({
      UMB_KEY:value
    })
  }

  get umt_libelle(){
    return this.modified.UMB_LIBELLE!
  }
  set umt_libelle(value:string){    
    this.$store.myActions.UNITEMOBILE_UPDATE_MODIFIED_ADM({
      UMB_LIBELLE:value
    })
  }

}
</script>